__turbopack_context__.v({
  "layout1": "IWrimW_layout1",
  "layout2": "IWrimW_layout2",
  "layout3": "IWrimW_layout3",
});
